import { FleekError } from './FleekError';

type ObjectId = {
  id?: string;
};

type PermissionGroupNotFoundErrorOptions = {
  permissionGroup: ObjectId;
};

export class PermissionGroupNotFoundError extends FleekError<PermissionGroupNotFoundErrorOptions> {
  public name = 'PermissionGroupNotFoundError';

  toString = () => 'Permission group not found';
}
